import { Address } from '../../models/address'

interface AddressFormatProps {
  address: Address
}

export function AddressFormat({ address }: AddressFormatProps) {
  return (
    <div>
      <div>
        {address.line1} {address.line2 ? <>, {address.line2}</> : null}
      </div>
      <div>
        {address.city}, {address.state}, {address.zip}
      </div>
    </div>
  )
}
